import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  contactForm: FormGroup;
  public submitted:boolean=false;
  public isposted:number=0;

  get f() {
    return this.contactForm.controls;
  }

  constructor(private titleService: Title, private metaService: Meta,  private fb: FormBuilder, protected http: HttpClient) { 

    this.contactForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: [''],
      email: ['', [Validators.required, Validators.email]],
      phone_number: ['', Validators.required],
      /* msg_subject: ['', Validators.required], */
      message: ['', Validators.required]
    });
  

  }

  ngOnInit(): void {
    // Fetch meta tags from API
    this.http.get('http://localhost:3000/api/contact').subscribe(
      (response: any) => {
        if (response.metaTags) {
          this.updateMetaTags(response.metaTags);
        }
      },
      (error) => {
        console.error('Error fetching meta tags:', error);
        // Fallback to default meta tags if API call fails
        this.titleService.setTitle('Contact RingPilot - Get in Touch with Our Communication Experts');
        this.metaService.updateTag({ name: 'description', content: 'Reach out to RingPilot for innovative communication solutions. Our team of experts is ready to help transform your business communication with cutting-edge technology and exceptional support.' });
        this.metaService.updateTag({ name: 'keywords', content: 'RingPilot contact, business communication, cloud contact center, customer engagement, communication solutions, enterprise communication' });
      }
    );
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.contactForm.invalid) {
      return;
    }

    console.log(this.contactForm.value);
    let cdata = JSON.stringify(this.contactForm.value);
    
      /*this.http.post<any>(environment.Portal3, { "data": cdata }, { headers: { "Content-Type": "application/json" } }).subscribe(res => {
        this.isposted=1;
        console.log(res);
      }, err => {
          console.log(err);
          this.isposted=1;
      });*/
  }

  Close(type:number){
    this.isposted=0;
    this.contactForm.reset();

    Object.keys(this.contactForm.controls).forEach(key => {
      this.contactForm.controls[key].setErrors(null);
    });
  }

  private updateMetaTags(metaTags: any[]): void {
    // Remove existing meta tags
    this.metaService.removeTag("name='description'");
    this.metaService.removeTag("name='keywords'");
    this.metaService.removeTag("name='author'");
    this.metaService.removeTag("property='og:title'");
    this.metaService.removeTag("property='og:description'");
    this.metaService.removeTag("property='og:image'");
    this.metaService.removeTag("property='og:url'");
    this.metaService.removeTag("property='og:type'");
    this.metaService.removeTag("name='twitter:card'");
    this.metaService.removeTag("name='twitter:title'");
    this.metaService.removeTag("name='twitter:description'");
    this.metaService.removeTag("name='twitter:image'");
    this.metaService.removeTag("rel='canonical'");

    // Add new meta tags
    metaTags.forEach(tag => {
      if (tag.name === 'title') {
        this.titleService.setTitle(tag.content);
      } else if (tag.charset) {
        this.metaService.updateTag({ charset: tag.charset });
      } else if (tag['http-equiv']) {
        this.metaService.updateTag({ 'http-equiv': tag['http-equiv'], content: tag.content });
      } else if (tag.rel === 'canonical') {
        this.metaService.updateTag({ rel: 'canonical', href: tag.href });
      } else {
        const metaTag: any = {};
        if (tag.name) metaTag.name = tag.name;
        if (tag.property) metaTag.property = tag.property;
        if (tag.content) metaTag.content = tag.content;
        this.metaService.updateTag(metaTag);
      }
    });
  }

}
